// extracted by css-extract-rspack-plugin
export default {"metabaseLink":"V6GFZ","light":"x6jdk","dark":"B2dWo"};